<template>
    <div class="body-info body-content-description has-footer-absolute" :class="{ 'themed-scrollbar' : isDesktop }">
        <form class="recipe-form" :novalidate="true">
            <p class="content-description"> {{ kStrings.kRECIPE_INFORMATION + ':'  }} </p>
            <div class="input-wrapper">
                <input v-model="recipeTitle" id="recipeTitle" :type="modalData.content.inputs.name.type" min="3" maxlength="200" class="normal-input" required/>
                <label for="recipeTitle" v-html="modalData.content.inputs.name.label"/>
            </div> 
            <div class="input-grid-wrapper">
                <div class="input-wrapper">
                    <input v-model="preparationTime" id="preparationTime" :type="modalData.content.inputs.preparationTime.type" min="3" maxlength="200" class="normal-input" required/>
                    <label for="preparationTime" v-html="modalData.content.inputs.preparationTime.label"/>
                </div>
                <div class="input-wrapper">
                    <input v-model="cookingTime" id="cookingTime" :type="modalData.content.inputs.cookingTime.type" min="3" maxlength="200" class="normal-input" required/>
                    <label for="cookingTime" v-html="modalData.content.inputs.cookingTime.label"/>
                </div>
            </div>
            <p class="content-description"> {{ kStrings.kRECIPE_INGREDIENTS + ':' }} </p>
            <div v-if="ingredientList.length" class="dynamic-input-wrapper">
                <div v-for="(ingredient, index) in ingredientList" :key="ingredient.id" class="input-wrapper">
                    <input v-model="ingredientList[index].value" id="ingredientList" :type="ingredient.type" min="3" maxlength="200" class="normal-input" :id="ingredient.id" required/>
                    <label for="ingredientList" v-html="ingredient.label"/>
                    <i v-if="((index + 1) == ingredientList.length) && !ingredientInputLimit"
                       class="ecom-plus"
                       @click="addIngredient(ingredientKey)"
                    />
                    <i v-if="(index + 1) != ingredientList.length"
                       class="ecom-close"
                       @click="removeIngredient(index)"
                    />
                </div>
            </div>
            <p class="content-description"> {{ kStrings.kRECIPE_MODE_PREP + ':' }} </p>
            <div v-if="preparationStepsList" class="dynamic-input-wrapper">
                <div v-for="(step, index) in preparationStepsList" :key="step.id" class="input-wrapper">
                    <input v-model="preparationStepsList[index].value" id="preparationStepsList" :type="step.type" min="3" maxlength="200" class="normal-input" required/>
                    <label for="preparationStepsList" v-html="index + 1 + 'º ' +  step.label"/>
                    <i v-if="((index + 1) == preparationStepsList.length) && !preparationStepsLimit"
                       class="ecom-plus"
                       @click="addPreparationStep(stepKey)"
                    />
                    <i v-if="(index + 1) != preparationStepsList.length"
                       class="ecom-close"
                       @click="removePreparationStep(index)"
                    />
                </div>
            </div>
            <p class="content-description"> {{ kStrings.kOBSERVATIONS + ':' }} </p>
            <div class="input-wrapper textarea-wrapper">
                <textarea v-model="observations" id="descriptionText" maxlength="1000" class="normal-input small free-label themed-scrollbar"/>
            </div>
            <p class="content-description"> {{ kStrings.kUSED_PRODUCTS + ':' }} </p>
            <div class="saved-list-container" :class="{ 'has-items' : selectedProductsList.length }">
                <div v-if="selectedProductsList" class="product-shop-list themed-scrollbar">
                    <div v-for="item in selectedProductsList" class="shop-item" :id="'shop-item-' + item.groupId">
                        <img :src="item.img" class="item-img" :alt="item.name"/>
                        <div class="mx-0 item-info-container">
                            <div class="col pl-0 prod-labels">
                                <p class="item-label name-label"> {{ item.name }} </p>
                                <p class="item-label light variant-label"> {{ item.label }} </p>
                            </div>
                            <div class="col-12 px-0 mt-auto action-labels">
                                <p class="item-label light qty-label"> {{ kStrings.kQUANTITY + ': ' }} <span> {{ item.quantity ? item.quantity : 1 }} </span> </p>
                            </div>
                        </div>
                        <i class="ecom-close remove-selected" @click.prevent="removeProdListItem(item)"/>
                    </div>
                </div>
            </div>
            <div class="button-wrapper m-0">
                <button class="pastime-button light" @click.prevent="toggleCatalogCart">
                    {{ kStrings.kADD_PRODUCT_RECIPES }}
                </button>
            </div>
        </form>
        <div class="button-wrapper modal-absolute" :class="{ 'fit-content' : isDesktop }">
            <button class="pastime-button dark-mode" @click.prevent="recipeFormSubmit" :disabled="!enableDescriptionFormSubmit">
                {{ kStrings.kSAVE_CHANGES }}
            </button>
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';
import sharedApi from '@/api/sharedApi';

export default {
    store,
    name: 'RecipeForm',
    components: {},
    props: {
        //prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
            // v-models
            recipeTitle: '',
            preparationTime: '',
            cookingTime: '',
            ingredientList: [],
            preparationStepsList: [],
            observations: '',
            // incremental ids/keys for dynamic inputs
            ingredientKey: 1,
            stepKey: 1
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        recipeForm() {
            return this.$store.getters['registrationPage/recipeForm']; 
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        requireUsedProducts() {
            return this.pastimeInfo.baseInfo.requireUsedProducts;
        },
        enableDescriptionFormSubmit() {
            let titleOk = !isEmpty(this.recipeTitle.trim());
            let preparationTimeOk = !isEmpty(this.preparationTime.trim());
            let cookingTimeOk = !isEmpty(this.cookingTime.trim());
            let ingredientListOk = !isEmpty(this.ingredientList) && !isEmpty(this.ingredientList.filter(elem => elem.value.length > 0));
            let preparationStepsListOk = !isEmpty(this.preparationStepsList) && !isEmpty(this.preparationStepsList.filter(elem => elem.value.length > 0));
            let selectedProductsListOk = !this.requireUsedProducts || !isEmpty(this.selectedProductsList);
            return titleOk && preparationTimeOk && cookingTimeOk && ingredientListOk && preparationStepsListOk && selectedProductsListOk;
        },
        // reached ingredient & pre time limits -> 20 each
        ingredientInputLimit() {
            return this.ingredientList.length == 20;
        },
        preparationStepsLimit() {
            return this.preparationStepsList.length == 20;
        },
        selectedProductsList() { // store list to submit
            return !isEmpty(this.$store.getters['registrationPage/selectedProductsList']) ? this.$store.getters['registrationPage/selectedProductsList'] : []
        },
    },
    watch: {},
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            // set default v-models if available
            this.setDefaultRecipeForm();
        });
    },
    methods: {
        setDefaultRecipeForm() {
            const inputs = this.modalData.content.inputs;
            this.recipeTitle = !isEmpty(inputs.name.defaultValue) ? inputs.name.defaultValue : '';
            this.preparationTime = !isEmpty(inputs.preparationTime.defaultValue) ? inputs.preparationTime.defaultValue : '';
            this.cookingTime = !isEmpty(inputs.cookingTime.defaultValue) ? inputs.cookingTime.defaultValue : '';
            this.ingredientList = !isEmpty(inputs.ingredientList) ? inputs.ingredientList : [];
            if(isEmpty(this.ingredientList)) {
                this.addIngredient(this.ingredientKey);
            }
            this.preparationStepsList = !isEmpty(inputs.preparationStepsList) ? inputs.preparationStepsList : [];
            if(isEmpty(this.preparationStepsList)) {
                this.addPreparationStep(this.stepKey);
            }
            
            this.observations = !isEmpty(inputs.observations.defaultValue) ? inputs.observations.defaultValue : '';
            this.productsList = !isEmpty(this.selectedProductsList) ? this.selectedProductsList : [];
        },
        addIngredient(position = -1) {
            //sharedApi.debug('added ingredient - key: ', position);
            let inputData = {
                index: position,
                id: 'ingredient-' + position,
                type: 'text',
                value: '',
                label: this.kStrings.kRECIPE_ADD_ONE_INGREDIENT,
            };
            
            this.ingredientList.push(inputData);
            this.ingredientKey++;
        },
        removeIngredient(index = -1) {
            //sharedApi.debug('removed ingredient - index: ', index);
            let targetIndex = [this.ingredientList[index]];
            //sharedApi.debug('target ingredient: ', targetIndex);
            if(targetIndex) {
                this.ingredientList = this.ingredientList.filter(element => !targetIndex.includes(element));
            }
        },
        addPreparationStep(position = -1) {
            //sharedApi.debug('added step - key: ', position);
            let inputData = {
                index: position,
                id: 'step-' + position,
                type: 'text',
                value: '',
                label: this.kStrings.kGLOB_STEP,
            };

            this.preparationStepsList.push(inputData);
            this.stepKey++;
        },
        removePreparationStep(index = -1) {
            //console.log('removed step - index: ', index);
            let targetIndex = [this.preparationStepsList[index]];
            //console.log('target step: ', targetIndex);
            if(targetIndex) {
                this.preparationStepsList = this.preparationStepsList.filter(element => !targetIndex.includes(element));
            }
        },
        recipeFormSubmit(close = true) {
            let data = {
                name: this.recipeTitle,
                preparationTime: this.preparationTime,
                cookingTime: this.cookingTime,
                ingredientList: this.ingredientList.filter(elem => elem.value.length > 0),
                preparationStepsList: this.preparationStepsList.filter(elem => elem.value.length > 0),
                observations: this.observations,
                selectedProductsList: this.selectedProductsList,
            };
            this.$store.dispatch('registrationPage/setRecipeForm', data);
            if(close) {
                this.$store.dispatch('setModalStatus', {status: false, context: null});
            }
        },
        toggleCatalogCart() {
            this.recipeFormSubmit(false);
            this.$store.dispatch('setModalStatus', {status: true, context: 'catalogCart', isMixType: true});
        },
        async removeProdListItem(prod = null) { // adds / remove items from selection
            if(prod) {
                let current = this.selectedProductsList;
                let found = current.find(item => item.groupId == prod.groupId);
                if(found) {
                    let updated = current.filter(item => item.groupId != prod.groupId);
                    await this.$store.dispatch('registrationPage/setSelectedProductsList', updated);
                }
            }
        },
    }
};
</script>

<style scoped>

</style>